export { WMLogger } from './src/log';
